import { render, staticRenderFns } from "./Vacancies.vue?vue&type=template&id=7b5b7c0b&scoped=true"
import script from "./Vacancies.vue?vue&type=script&lang=js"
export * from "./Vacancies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b5b7c0b",
  null
  
)

export default component.exports